<template>
  <div>
    <Settings ref="settings" />
    <PickProductUnitAndBatch
      @addProduct="addProductToBill"
      :data="selected"
      ref="PickProductUnitAndBatch"
    />
    <div>
      <b-row class="m-1">
        <b-col cols="4" class="float-end pr-1 pl-1">
          <!-- <PickProduct /> -->
          <b-form-input
            v-model="searchString"
            class="v-select-product"
            @input="FilterProduct()"
            placeholder="Product Name"
          >
          </b-form-input>
        </b-col>
        <b-col cols="4" class="float-end pr-1 pl-1">
          <v-select
            v-model="selectedCategory"
            :clearable="false"
            class="v-select-product"
            :get-option-label="(option) => option.text"
            :options="categoriesList"
            placeholder="select category"
            @input="FilterProduct"
          />
        </b-col>
        <b-col cols="4" class="float-end pr-1 pl-1">
          <v-select
            v-model="selectedBrand"
            :clearable="false"
            class="v-select-product"
            :get-option-label="(option) => option.text"
            :options="brandsList"
            placeholder="select brand"
            @input="FilterProduct"
          />
        </b-col>

        <b-col class="text-center" v-if="IsShopNull">
          <b-alert show variant="warning">
            Shop not selected
            <b-btn @click="chooseShop" class="ml-3" size="md"
              >Choose shop
            </b-btn>
          </b-alert>
        </b-col>
        <b-col class="text-center" v-if="filtered">
          <div>
            Products Filtered.
            <b-btn size="sm" @click.stop="AllProducts()">Cancel filter</b-btn>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-row class="p-3 product-area">
      <b-col
        class="text-center noProducts_msg"
        v-if="products.length == 0 && !isServiceVisible"
      >
        No Products found
      </b-col>
      <b-col
        class="text-center noProducts_msg"
        v-if="services.length == 0 && isServiceVisible"
      >
        No Services found
      </b-col>
      <vue-paginate-scroll
        v-if="isServiceVisible && !loading"
        :src="services"
        :per-scroll="20"
      >
        <template slot-scope="{ data, currentScroll, lastScroll }">
          <b-row v-if="isServiceVisible">
            <b-col
              cols="12"
              :xs="view == 'lines' ? 12 : 12"
              :sm="view == 'lines' ? 12 : 6"
              :md="view == 'lines' ? 12 : 2"
              :lg="view == 'lines' ? 12 : 4"
              :xl="view == 'lines' ? 12 : 2"
              v-for="(service, index) in services"
              :key="index"
            >
              <br />

              <div
                class="product2_wrapper"
                @click.prevent="Addservice(service)"
              >
                <div class="product2_image">
                  <img
                    v-if="service.image"
                    :src="service.image"
                    data-src="img/location_1.jpg"
                  />
                  <img v-else src="../../assets/img/no-photo.svg" height="60" />
                </div>
                <div class="product2_title">{{ service.name }}</div>
              </div>
            </b-col>
          </b-row>
        </template>
      </vue-paginate-scroll>
      <!-- {{ loading }} -->
      <div v-if="loading">
        <i
          class="fa fa-refresh"
          :class="loading ? 'fa-spin' : ''"
          aria-hidden="true"
        ></i>
      </div>
      <vue-paginate-scroll
        v-if="!isServiceVisible && !loading"
        :src="products"
        :per-scroll="20"
      >
        <template slot-scope="{ data, currentScroll, lastScroll }">
          <!-- <div
            class="d-flex py-1 px-2 bg-primary rounded-lg text-white fixed"
            style="    position: absolute;
              z-index: 999;
              width: 39%;"
          >
            <div class="mr-3">{{ data.length }} / {{ products.length }}</div>
            <div class="mr-3">
              <strong>Current scoll:</strong>
              {{ currentScroll }}
            </div>
            <div class="mr-3">
              <strong>Last scoll:</strong>
              {{ lastScroll }}
            </div>
          </div> -->
          <b-row>
            <b-col
              cols="12"
              :xs="view == 'lines' ? 12 : 12"
              :sm="view == 'lines' ? 12 : 6"
              :md="view == 'lines' ? 12 : 2"
              :lg="view == 'lines' ? 12 : 4"
              :xl="view == 'lines' ? 12 : 2"
              v-for="(product, index) in data"
              :key="index"
            >
              <br />

              <div
                class="product2_wrapper"
                @click.prevent="AddProduct(product)"
              >
                <div class="product2_image">
                  <img
                    v-if="product.image"
                    :src="product.image"
                    data-src="img/location_1.jpg"
                  />
                  <img v-else src="../../assets/img/no-photo.svg" height="60" />
                </div>
                <div class="product2_title">{{ product.name }}</div>
              </div>
            </b-col>
          </b-row>
        </template>
      </vue-paginate-scroll>

      <!-- <b-col
        v-if="!isServiceVisible"
        cols="12"
        :xs="view == 'lines' ? 12 : 12"
        :sm="view == 'lines' ? 12 : 6"
        :md="view == 'lines' ? 12 : 2"
        :lg="view == 'lines' ? 12 : 4"
        :xl="view == 'lines' ? 12 : 2"
        v-for="(product, index) in products"
        :key="index"
      >
        <br />

        <div class="product2_wrapper" @click.prevent="AddProduct(product)">
          <div class="product2_image">
            <img
              v-if="product.image"
              :src="product.image"
              data-src="img/location_1.jpg"
            />
            <img v-else src="../../assets/img/no-photo.svg" height="60" />
          </div>
          <div class="product2_title">
            {{ product.name }}
          </div>
        </div>
      </b-col> -->
    </b-row>
  </div>
</template>

<script>
// Components
import PickProductUnitAndBatch from "@/components/shared/PickProductUnitAndBatch";
import Settings from "@/components/Settings/index";
import PickProduct from "@/components/shared/PickProduct";

// Models
import { BillModel, BillDecorator } from "@/models/BillModel";
import { UnitDecorator } from "@/models/UnitModel";
import { BatchDecorator } from "@/models/BatchModel";

// Mixins
import Products from "@/mixins/Products";
import Categories from "@/mixins/Categories";
import Brands from "@/mixins/Brands";

import { mapState, mapGetters } from "vuex";
export default {
  name: "ProductList",
  mixins: [Products, Categories, Brands],
  data: () => ({
    processing: false,
    view: "grid",
    selectedCategoryIndex: -1,
    isServiceVisible: false,
    isServiceVisibleItem: null,
    amount: null,
    // productImages: [
    //   'https://cdn.pixabay.com/photo/2019/07/13/13/42/watch-4334815_960_720.jpg',
    //   'https://images.macrumors.com/t/u5qFUnuK3qopG8nIsOOX74kgtk8=/1600x0/article-new/2019/02/MR-Future-Products-2020-2.png',
    //   'https://www.nivea.in/-/media/local/in/boday_page/3_banner_3080x806.png?rx=626&ry=0&rw=2063&rh=806',
    //   'https://upload.wikimedia.org/wikipedia/commons/6/65/Product_Photography.jpg',
    //   'https://pauliusmusteikisphoto.com/wp-content/uploads/2015/04/commercial_product_photography_Madison_WI_by_Paulius_Musteikis_Photography-1146.jpg',
    //   'https://www.coghlans.com/images/products/products-camp-kitchen-thumb.jpg',
    //   'https://monatglobal.com/wp-content/uploads/2019/08/MAGNIFY-SYSTEM-500x438-2019.png',
    //   'https://i1.adis.ws/i/canon/EOS-r5_Martin_Bissig_Lifestyle_hero-e90f9dd2-be19-11ea-b23c-8c04ba195b5f?w=100%&sm=aspect&aspect=16:9&qlt=80&fmt=jpg&fmt.options=interlaced&bg=rgb(255,255,255)',
    //   'https://www.coca-colacompany.com/content/dam/journey/us/en/brands/brands-landing/brands-landing-sparkling-masthead-770x790.jpg',
    //   'https://product.indiashoppe.com/7620.png',
    //   'https://cdn.shopify.com/s/files/1/0242/1866/5056/products/acv_32_side01_1024x1024_402x_1024x1024@2x.jpg?v=1594015117',
    //   'https://www.gs1india.org/media/Juice_pack.jpg',
    //   'https://d22skjp9e6l0hj.cloudfront.net/skin/frontend/bioNew/default/images/natural-makeup-collection.jpg',
    //   'https://www.thebodyshop.in/media/wysiwyg/Homepage/Iconic--2.jpg',
    // ],
    selected: Object.assign({}, BillModel),
    selectedCategory: "",
    selectedBrand: "",
    searchString: "",
  }),
  methods: {
    FilterProduct() {
      if (this.selectedCategory.text == "Services") {
        this.$store.dispatch("product/fetchServices");
        this.isServiceVisible = true;
      } else {
        this.isServiceVisible = false;
        this.$store.dispatch("product/fetchProducts", {
          query: this.searchString,
          category: this.selectedCategory.value,
          brand: this.selectedBrand.value,
        });
      }
    },
    chooseShop() {
      this.$refs.settings.showModal();
    },
    Addservice(index) {
      // this.isServiceVisibleItem = index;

      this.$store.dispatch("bill/AddService", index);
    },
    // FilterProducts(index) {

    //   if (!isNaN(index)) {
    //     this.selectedCategoryIndex = index;

    //     if (index == 1) {
    //       this.isServiceVisible = true;
    //       this.$store.dispatch("product/fetchServices");
    //     }
    //     else if (index == 0) {
    //       this.isServiceVisible = false;
    //       this.$store.dispatch("product/fetchProducts");
    //     }

    //     else {
    //       this.isServiceVisible = false;

    //       this.$store.dispatch("product/fetchProducts", {
    //         category: this.categories[index].id
    //       });
    //     }
    //   }
    // },
    addProductToBill(data) {
      var product = this.selected;
      if (data.setCurrentMoneyVisible) {
        product.price = data.setCurrentMoney;
      } else {
        product.price = data.batch.selling_price;
      }
      product.minCurrentMoneyVisible = data.setCurrentMoneyVisible;
      product.batch = data.batch;
      product.unit = data.unit;
      product.available_stock = data.available_stock;
      product.productInformation = data.productInformation;

      this.$store.dispatch(
        "bill/AddProduct",
        new BillDecorator(product).toBill()
      );
    },
    changeView(view) {
      this.view = view;
    },
    AllProducts() {
      this.isServiceVisible = false;
      this.searchString = "";
      this.selectedBrand = "";
      this.selectedCategory = "";
      this.selectedCategoryIndex = -1;
      this.$store.dispatch("product/fetchProducts");
    },
    openModal() {
      this.$refs.PickProductUnitAndBatch.showModal();
    },
    AddProduct(product) {
      if (this.processing === true) {
        return;
      }
      this.processing = true;
      setTimeout(() => {
        this.selected = new BillDecorator(product).toRequest();
        this.openModal();
        this.processing = false;
      }, 1000);

      // this.$store
      //   .dispatch("bill/AddProduct", product)
      //   .then((res) => {})
      //   .catch((err) => {});
    },
  },
  computed: {
    ...mapState("product", ["filtered", "loading"]),
    ...mapState("product", ["services"]),
    ...mapState("product", ["categories"]),
    ...mapGetters("shops", ["IsShopNull"]),
    categoriesList: function () {
      if (this.categories) {
        return this.categories.map((item) => ({
          value: item.id,
          text: item.name,
        }));
      }
    },
    brandsList: function () {
      return this.brands.map((item) => ({ value: item.id, text: item.name }));
    },
  },
  components: {
    PickProductUnitAndBatch,
    Settings,
    PickProduct,
  },
};
</script>

<style scoped>
.product-area {
  height: calc(100vh - 165px);
  overflow: scroll;
}
.vue-infinite-scroll {
  width: 100%;
}
html {
  scroll-behavior: smooth;
}
.block {
  margin-bottom: unset !important;
}

.block-content {
  padding: 4px 10px 1px !important;
}

.product_area {
  height: 100px;
  width: 100%;
  border: 1px solid #16294742 !important;
  border-radius: 15px;
  padding: 8px;
  /* text-align: center; */
}

.category_area {
  /* height: 110px; */
  width: 100%;
  border: 1px solid #16294742 !important;
  border-radius: 15px;
  padding: 8px;
  text-align: center;
}

.categoryFilled {
  background-color: #f07613;
  border: unset !important;
}

.categoryFilled .product_name {
  color: white;
}

.product_name {
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  color: #162947;
  height: 32px;
}

.product_image .image,
.product_image img {
  background-size: contain;
  height: 60px;
  width: 100%;
  border-radius: 13px;
  float: right;
}

.noProducts_msg {
  padding: 10px;
  background-color: aliceblue;
  color: #8e1c1c;
}

.strip figure {
  margin-bottom: 5px;
  overflow: hidden;
  position: relative;
  height: 190px;
  border-radius: 5px;
  background-color: #ededed;
}

.strip figure {
  height: 140px;
}

.strip figure img {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) scale(1);
  transform: translate(-50%, -50%) scale(1);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  width: 100%;
  z-index: 0;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.strip figure img {
  top: 40% !important;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

.strip figure a.strip_info {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
  display: block;
}

.strip figure .item_title h3 {
  font-size: 18px;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 500;
  color: #fff;
  margin: 0;
  padding: 0;
  line-height: 1;
}

.strip figure .item_title {
  width: 100%;
  position: absolute;
  bottom: 0;

  left: 0;
  padding: 45px 15px 10px 85px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(5%, transparent),
    to(black)
  );
  background: linear-gradient(to bottom, transparent 5%, black 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0);
}

.strip figure .item_title1 {
  width: 100%;
  position: absolute;
  bottom: 0;

  left: 0;
  padding: 45px 15px 10px 85px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(5%, transparent),
    to(black)
  );
  background: linear-gradient(to bottom, transparent 100%, black 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0);
}

.strip {
  position: relative;
  margin-bottom: 15px;
  /* background: #FFFFFF;
  box-shadow: 0px 14px 40px rgba(109, 141, 173, 0.25);
  border-radius: 5px; */
}

.Addbutton {
  margin-left: 53px;
  width: 113px;
  height: 27px;
  border-radius: 4px;
  z-index: 11111;
  background: #20b904;
  border: none;
  margin-top: 2px;
}

.CloseButton {
  margin-left: 53px;
  width: 113px;
  height: 27px;
  z-index: 11111;
  border-radius: 4px;
  background: #ec3b3b;
  border: none;
  margin-top: 2px;
}

.inputFieldAmount {
  margin-top: 35px;
  width: 100px;
  margin-left: -27px;
  height: 34px;
  outline: none;
  border: none;
}

.product2_wrapper {
  margin: auto;
  background-color: #ffffff;
  width: 100%;
  text-align: center;
  padding: 20px;
  height: 130px;

  display: flex;
  /* align-content: space-between; */
  justify-content: space-around;
  flex-direction: column;
}

.product2_image {
  width: 30px;
  margin: auto;
  /* background: #FFFFFF; */
  /* box-shadow: 0px 14p  x 40px rgba(109, 141, 173, 0.25); */
  border-radius: 5px;
}

.product2_title {
  width: 100%;
}

.search-input {
  height: 38px;
}

@media (min-width: 1200px) {
  .col-xl-2 {
    flex: 1 0 24.666667%;
    min-width: 24.666667%;
    max-width: 24.666667%;
  }
}

.v-select-product {
  background-color: #fff !important;
  border-radius: 10px !important ;
  border-color: white !important;
}
</style>
